export function parseImageMd5toUrl(
	domain: string,
	md5: string,
	width = 80,
	height = 80,
	color = '000000',
	dir = 'misc',
	quality = 90,
): string {
	const ext = color === 'none' ? 'png' : 'jpg';
	return `${domain}/${dir}/${md5}/${height}x${width}-${color}-${quality}-1-1.${ext}`;
}
